<div
  class="card smaller configuration-panel-card k-mt-5 collapsible"
  [ngClass]="expanded() ? 'collapsed' : 'expanded'"
>
  <div class="card-header">
    <div class="k-pos-relative k-w-full k-d-flex k-justify-content-between k-align-items-center">
      <span>Inhaltsbereiche</span>
      <button
        kendoButton
        rounded="full"
        size="small"
        themeColor="secondary"
        class="icon-xs"
        [attr.aria-expanded]="expanded()"
        [svgIcon]="chevronDownIcon"
        (click)="toggleVisibility()"
      ></button>
    </div>
  </div>
  <div class="card-body" appCollapsible [expanded]="expanded()">
    <div id="section-handling">
      @for (sectionGroup of sectionsByGroup(); track sectionGroup[0]) {
        @let groupName = sectionGroup[0];
        @let groupSections = sectionGroup[1];

        <div class="document-section">
          <h5 class="group-header k-mb-3">{{ groupName }}</h5>
          @for (section of groupSections; track section.id) {
            <div
              class="section-row k-mb-2.5 k-d-grid"
              (mouseenter)="hover(section.id)"
              (mouseleave)="hover(null)"
              [class.is-hovered]="editDocumentAreaService.hovered() === section.id"
              [class.is-current]="editDocumentAreaService.selected()?.sectionId === section.id"
            >
              <div class="section-label" title="{{ section.label }}">
                {{ section.label }}
              </div>

              <div class="section-controls">
                <app-edit-document-section-control
                  [sectionId]="section.id"
                  [sectionType]="section.defaultContent.type"
                  [sectionHidden]="isHidden()(section.id)"
                  [sectionRemoved]="isRemoved()(section.id)"
                />
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
